// ==============================|| OVERRIDES - LINER PROGRESS ||============================== //

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          padding: '16px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '17px',
          maxWidth: 350,
          position: 'relative',
          paddingRight: '30px',
          borderRadius: '8px',
          boxShadow: theme.shadows[5],
        },
        arrow: {
          fontSize: '21px',
        },
      },
    },
  };
}
